import { useCallback } from 'react';

import S from 'constants/string.const';
import logger from 'utils/logger.util';

const L = logger('useCallbackUnignored'); // eslint-disable-line no-unused-vars

const useCallbackUnignored = (callback, deps, ...tags) =>
  useCallback(
    (...args) => {
      const promise = callback(...args);

      if (promise instanceof Promise) {
        promise.catch((reason) => L.warn('()', ...tags, S.redFlag, deps, S.redFlag, ...args, S.redFlag, reason));
      } else {
        L.error('()', ...tags, S.redFlag, deps, S.redFlag, ...args, S.redFlag, 'Result is not a promise:', promise);
      }

      return promise;
    },
    deps, // eslint-disable-line react-hooks/exhaustive-deps
  );

export default useCallbackUnignored;
